/**
 * PMX — Stile Black (PARMAX) — script globale.
 * - Fase promo lato browser (Black Month / Week / Friday): aggiorna label prezzi,
 *   testi con [data-pmx-fase], blocchi [data-pmx-only] e barra promo, anche se la pagina
 *   arriva dalla cache di Shopify con la fase precedente.
 * - Countdown [data-pmx-countdown] alla fine della fase (solo nelle ultime N ore).
 * - Header pieno: classi pmx-hdr-hidden (sparisce scendendo, torna risalendo; ferma con
 *   menu/carrello/ricerca aperti) e pmx-scrolled (ombra) SULLA SEZIONE HEADER, non su <html>:
 *   una classe su <html> obbliga il browser a ricalcolare lo stile di tutta la pagina.
 *   Variabili --pmx-hdr-h / --pmx-bar-h.
 * - Comparsa lenta delle sezioni (.pmx-rv) e parallax leggero ([data-pmx-parallax]).
 * Configurazione: window.PMX_PROMO (sections/pmx-bf-style.liquid).
 */
(() => {
  if (window.PMX_BF_INIT) return;
  window.PMX_BF_INIT = true;

  const P = window.PMX_PROMO || null;
  const html = document.documentElement;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const PHASES = ['black_month', 'black_week', 'black_friday'];

  /* ---------- Fase ---------- */
  const phaseNow = () => {
    if (!P) return null;
    if (P.force && P.force !== 'auto' && (PHASES.includes(P.force) || P.force === 'fine')) return P.force;
    const now = Date.now() / 1000;
    if (now >= P.t.fine) return 'fine';
    if (now >= P.t.black_friday) return 'black_friday';
    if (now >= P.t.black_week) return 'black_week';
    return 'black_month';
  };
  const phaseEnd = (k) => {
    if (!P || (P.force && P.force !== 'auto')) return null;
    if (k === 'black_month') return P.t.black_week;
    if (k === 'black_week') return P.t.black_friday;
    if (k === 'black_friday') return P.t.fine;
    return null;
  };
  const titleCase = (s) => String(s).toLowerCase().replace(/(^|\s)\S/g, (m) => m.toUpperCase());

  let key = phaseNow();

  const applyPhase = (root = document) => {
    if (!P || !key) return;
    const name = P.n[key] || '';
    html.setAttribute('data-pmx-phase', key);
    const others = PHASES.map((k) => P.n[k]).filter((n) => n && n !== name);

    root.querySelectorAll('.price__checkout-badge').forEach((el) => {
      let t = el.textContent;
      others.forEach((n) => { if (t.includes(n)) t = t.split(n).join(name); });
      if (t !== el.textContent) el.textContent = t;
    });
    root.querySelectorAll('[data-pmx-fase]').forEach((el) => {
      const v = el.dataset.pmxFase === 'title' ? titleCase(name) : name;
      if (el.textContent !== v) el.textContent = v;
    });
    root.querySelectorAll('[data-pmx-only]').forEach((el) => {
      el.hidden = !el.dataset.pmxOnly.split(/[\s,]+/).includes(key);
    });
  };

  /* ---------- Barra promo ---------- */
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const initBar = () => {
    const bar = document.querySelector('[data-pmx-bar]');
    if (!bar || !P) return;
    let texts = {};
    try { texts = JSON.parse(bar.querySelector('[data-pmx-bar-texts]').textContent); } catch (e) { return; }
    const t = texts[key] || '';
    const out = bar.querySelector('[data-pmx-bar-text]');
    const htmlText = t.replace(/\[fase\]/g, `<span data-pmx-fase="name">${esc(P.n[key] || '')}</span>`);
    if (out && out.innerHTML !== htmlText) out.innerHTML = htmlText;
    bar.classList.toggle('pmx-bar--empty', !t);
  };

  /* ---------- Countdown ---------- */
  const pad = (n) => String(n).padStart(2, '0');
  const cds = [];
  const tickCountdowns = () => {
    const end = phaseEnd(key);
    const now = Date.now() / 1000;
    cds.forEach((el) => {
      const win = parseFloat(el.dataset.window || '48') * 3600;
      const left = end ? Math.floor(end - now) : -1;
      const show = left > 0 && left <= win;
      el.hidden = !show;
      if (!show) return;
      const d = Math.floor(left / 86400);
      const h = Math.floor((left % 86400) / 3600);
      const m = Math.floor((left % 3600) / 60);
      const s = left % 60;
      const out = el.querySelector('[data-pmx-cd-out]') || el;
      const txt = `${d > 0 ? `${d}g ` : ''}${pad(h)}h ${pad(m)}m ${pad(s)}s`;
      if (out.textContent !== txt) out.textContent = txt;
    });
    if (end && now >= end) { key = phaseNow(); applyPhase(); initBar(); }
  };
  const initCountdowns = () => {
    document.querySelectorAll('[data-pmx-countdown]').forEach((el) => { if (!cds.includes(el)) cds.push(el); });
    if (cds.length && !initCountdowns.timer) {
      tickCountdowns();
      initCountdowns.timer = setInterval(tickCountdowns, 1000);
    }
  };

  /* ---------- Header: sempre pieno, sparisce scendendo e torna risalendo ----------
     (durante lo scatto delle schermate pmx-bf-stack.js aggiunge .pmx-snap-hide all'header) */
  let hdrEl = null;
  const hdr = () => hdrEl || (hdrEl = document.querySelector('.cc-header'));
  // posizione "a riposo" e altezza dell'header: lette solo al cambio di dimensioni, mai durante lo scroll
  let hdrRest = 0;
  let hdrH = 0;
  const setHeaderVars = () => {
    const h = hdr();
    if (!h) return;
    hdrH = h.offsetHeight;
    const prev = h.previousElementSibling; // offsetTop di un elemento sticky segue lo scroll
    hdrRest = prev ? prev.offsetTop + prev.offsetHeight : 0;
    html.style.setProperty('--pmx-hdr-h', `${hdrH}px`);
    const bar = document.querySelector('.pmx-bar-section');
    html.style.setProperty('--pmx-bar-h', `${bar ? bar.offsetHeight : 0}px`);
  };
  const hdrClass = (c, v) => {
    const h = hdr();
    if (h && h.classList.contains(c) !== v) h.classList.toggle(c, v);
  };

  // Pagina bloccata da menu, carrello, ricerca, filtri: l'header non deve cambiare stato.
  // Calcolato solo quando cambiano classi/stile di html e body (non a ogni fotogramma di scroll).
  const computeLocked = () => {
    if (html.classList.contains('pmx-snap-hold')) return false; // scatto delle schermate su mobile
    if (html.classList.contains('adr-mm-open')) return true;
    const b = document.body;
    const cb = getComputedStyle(b);
    if (cb.position === 'fixed' || cb.overflow === 'hidden' || cb.overflowY === 'hidden') return true;
    const ch = getComputedStyle(html);
    return ch.overflow === 'hidden' || ch.overflowY === 'hidden';
  };
  let locked = false;
  const isLocked = () => locked;

  let lastY = window.scrollY;
  let wasLocked = false;
  let unlockedAt = 0;
  let ticking = false;
  const setHidden = (v) => hdrClass('pmx-hdr-hidden', v);
  const updateHeader = () => {
    ticking = false;
    const y = Math.max(0, window.scrollY);
    const now = performance.now();
    // pannello aperto: l'header resta com'e' (nessun movimento dietro menu/carrello)
    if (isLocked()) { wasLocked = true; lastY = y; return; }
    if (wasLocked) { wasLocked = false; unlockedAt = now; }
    if (now - unlockedAt < 600) { lastY = y; return; } // scroll ripristinato alla chiusura di un pannello
    const h = hdr();
    const top = hdrRest;
    const hh = hdrH;
    hdrClass('pmx-scrolled', y > top + 4);
    if (y <= top + hh) { setHidden(false); lastY = y; return; }
    const d = y - lastY;
    if (Math.abs(d) < 8) return;
    if (d > 0) {
      if (h && h.classList.contains('pmx-hdr-hidden')) { lastY = y; return; } // gia' nascosto: nessun controllo
      // ricerca in uso (campo attivo o risultati aperti) o mouse sul menu: l'header resta
      const ae = document.activeElement;
      const res = h && h.querySelector('.js-search-results');
      const busy = h && ((h.contains(ae) && ae.matches('input, textarea, select'))
        || (res && res.offsetHeight > 0)
        || (window.matchMedia('(hover: hover)').matches && h.matches(':hover')));
      if (!busy) setHidden(true);
    } else {
      setHidden(false);
    }
    lastY = y;
  };
  const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(updateHeader); } };

  /* ---------- Comparsa lenta + parallax ---------- */
  // Le sezioni con pannelli a schermo intero (filtri, carrello, popup) restano escluse:
  // un transform su un antenato sposterebbe i loro elementi position:fixed.
  const FIXED_SEL = 'cart-drawer, facet-filters, details-modal, quick-add-drawer, localization-drawer, dialog, [class*="drawer"], [class*="modal"], [class*="popup"], [id*="drawer"], [id*="Drawer"], [id*="modal"], [id*="Modal"]';
  const initReveal = () => {
    if (reduce || !html.classList.contains('pmx-reveal-on') || !('IntersectionObserver' in window)) return;
    // pagine con il reel (schermate come prima sezione): le sezioni arrivano gia' a scatto
    if (document.querySelector('#main-content > .shopify-section:first-child pmx-stack')) return;
    const done = (el) => {
      el.classList.remove('pmx-rv', 'pmx-rv-in');
    };
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        const el = e.target;
        io.unobserve(el);
        el.classList.add('pmx-rv-in');
        // a fine animazione tolgo le classi: nessun transform/opacity resta sulla sezione
        let t = null;
        const end = (ev) => {
          if (ev && (ev.target !== el || ev.propertyName !== 'transform')) return;
          clearTimeout(t);
          el.removeEventListener('transitionend', end);
          done(el);
        };
        el.addEventListener('transitionend', end);
        t = setTimeout(end, 1800);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.01 });
    const vh = window.innerHeight;
    const targets = [
      ...document.querySelectorAll('#main-content > .shopify-section:not(:first-child):not(.pmx-no-rv)'),
      ...document.querySelectorAll('[data-pmx-reveal]')
    ];
    targets.forEach((el) => {
      if (el.querySelector('.pmx-stack')) return;
      if (el.matches(FIXED_SEL) || el.querySelector(FIXED_SEL)) return;
      if (el.getBoundingClientRect().top < vh * 0.9) return;
      el.classList.add('pmx-rv');
      io.observe(el);
    });
  };

  const initParallax = () => {
    if (reduce) return;
    const els = [...document.querySelectorAll('[data-pmx-parallax]')];
    if (!els.length) return;
    let ticking = false;
    const run = () => {
      ticking = false;
      const vh = window.innerHeight;
      els.forEach((el) => {
        const r = el.parentElement.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        const f = parseFloat(el.dataset.pmxParallax || '0.08');
        const delta = (r.top + r.height / 2 - vh / 2) * -f;
        el.style.transform = `translate3d(0, ${delta.toFixed(1)}px, 0) scale(${1 + f * 1.6})`;
      });
    };
    const req = () => { if (!ticking) { ticking = true; requestAnimationFrame(run); } };
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', req);
    run();
  };

  /* ---------- Avvio ---------- */
  const start = () => {
    applyPhase();
    initBar();
    initCountdowns();
    setHeaderVars();
    locked = computeLocked();
    updateHeader();
    initReveal();
    initParallax();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => { setHeaderVars(); locked = computeLocked(); });
    if ('ResizeObserver' in window) {
      const h = hdr();
      if (h) {
        const ro = new ResizeObserver(setHeaderVars);
        ro.observe(h);
        if (h.previousElementSibling) ro.observe(h.previousElementSibling); // barra promo sopra
      }
    }

    // Label e testi inseriti dopo (filtri AJAX, varianti, griglie Black, quick add)
    let pending = false;
    new MutationObserver((muts) => {
      if (pending) return;
      if (!muts.some((m) => m.addedNodes.length)) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; applyPhase(); initCountdowns(); });
    }).observe(document.body, { childList: true, subtree: true });

    // Apertura/chiusura di menu/carrello/ricerca: l'header resta fermo e riparte senza scatti
    const lockWatch = new MutationObserver(() => { locked = computeLocked(); onScroll(); });
    lockWatch.observe(html, { attributes: true, attributeFilter: ['class', 'style'] });
    lockWatch.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });

    // Menu mobile ADR: la pagina dietro non scorre, senza overflow:hidden (su iPhone faceva
    // ridimensionare la pagina sotto il menu = sfarfallio). Scorrono solo i pannelli del menu.
    const mm = document.getElementById('AdrMM');
    if (mm) {
      mm.addEventListener('touchmove', (e) => {
        const panel = e.target.closest && e.target.closest('.adr-mm__panel');
        if (!panel || panel.scrollHeight <= panel.clientHeight + 1) e.preventDefault();
      }, { passive: false });
    }
  };

  window.PMX_BF = { phase: () => key, applyPhase, phaseEnd };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
